import { withStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Create';
import Card from 'components/CncUI/Card';
import Button from 'components/CncUI/Button';

const styles = ({ palette, breakpoints }) => ({
  button: {
    padding: '2px 4px',
    color: palette.cncUI.default['+10'],
    '&:hover': {
      color: palette.cncUI.default['+10'],
    },
    '&:focus': {
      color: palette.cncUI.default['+10'],
    },
    '&:active': {
      color: palette.cncUI.default['+10'],
    },
  },
  content: {
    padding: '40px 24px 56px 24px !important',
  },
});

const Box = props => {
  const { title, children, classes, onEdit } = props;
  const key = `ProfileBox-${title.replace(/\s/g, '')}`;
  const action = onEdit && (
    <Button
      tertiary
      onClick={onEdit}
      className={classes.button}
      startIcon={<EditIcon />}
      id={`${key}-EditButton`}
    >
      edit
    </Button>
  );

  return (
    <Card id={key}>
      <Card.Title action={action}>{title}</Card.Title>
      <Card.Content className={classes.content}>{children}</Card.Content>
    </Card>
  );
};

export default withStyles(styles)(Box);
